import React, { useCallback } from 'react';
import { useProviderHelpers } from './ProviderHelpers';

const Context = React.createContext();

export const ReportApplicationProvider = ({ children }) => {
    const { data, execute, clearData } = useProviderHelpers();

    const listRecords = useCallback(async (props) => {
        await execute({ scope: 'list', url: `Report/GetSelectedApps/${props.reportId}`, method: 'GET', secure: true });
    }, [execute]);

    const updateRecord = useCallback(async (props) => {
        await execute({ scope: 'update', url: `Report/SetSelectedApps/${props.reportId}`, method: 'POST', payload: props.applications, secure: true });
    }, [execute]);


    const value = { listRecords, updateRecord, data, clearData };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useReportApplicationStore = () => React.useContext(Context);
